module.exports = __webpack_public_path__ + "img/6.f06717a1.png";